import { useEffect, useRef } from 'react';

export default function useScrollUnlock(onCheckStateChange) {
  const rootRef = useRef(null);

  useEffect(() => {
    const screenContainer = rootRef.current?.closest('.screen-container');
    const threshold = 24;

    if (!screenContainer) {
      return undefined;
    }

    const updateScrollState = () => {
      const containerCanScroll =
        screenContainer.scrollHeight - screenContainer.clientHeight > 1;

      const hasReachedBottom = containerCanScroll
        ? screenContainer.scrollTop + screenContainer.clientHeight >=
          screenContainer.scrollHeight - threshold
        : (rootRef.current?.getBoundingClientRect().bottom ?? Infinity) <=
          (window.visualViewport?.height || window.innerHeight) + threshold;

      onCheckStateChange?.({
        checked: false,
        canCheck: hasReachedBottom,
        onCheck: null,
      });
    };

    updateScrollState();
    screenContainer.addEventListener('scroll', updateScrollState, { passive: true });
    window.addEventListener('scroll', updateScrollState, { passive: true });
    window.addEventListener('resize', updateScrollState);
    window.visualViewport?.addEventListener('resize', updateScrollState);

    return () => {
      screenContainer.removeEventListener('scroll', updateScrollState);
      window.removeEventListener('scroll', updateScrollState);
      window.removeEventListener('resize', updateScrollState);
      window.visualViewport?.removeEventListener('resize', updateScrollState);
    };
  }, [onCheckStateChange]);

  return rootRef;
}
